var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"training-update-container linegraph-wrapper",attrs:{"xl":"9","lg":"12"}},[(_vm.data)?_c('Highcharts',{ref:"lineGraphTraining",attrs:{"options":_vm.options}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }